import React from 'react';
import styles from './ncmViewContainer.module.scss';
import InformacaoBasica from './components/informacaoBasica/informacaoBasica';
import { ICodigoNcm } from './../../../../interfaces/IBaseDeCalculo';
import { formatCurrency } from './../../../../utils/formatCurrency';
import { BrButton } from '@govbr-ds/react-components';
import { formatStringToBR } from '../../../../utils/formatNumber';

interface INCMViewContainerProps {
  codigoNCM: ICodigoNcm;
  hideAction?: boolean;
  onRemove?: (codigo: ICodigoNcm) => void;
}

const NCMViewContainer: React.FC<INCMViewContainerProps> = ({ codigoNCM, hideAction, onRemove }) => {
  const removerNCM = (codigoNCM: ICodigoNcm) => {
    if (onRemove) {
      onRemove(codigoNCM);
    }
  };

  return (
    <div className={styles.containerNCM}>
      <InformacaoBasica
        aria-label={`Código NCM: ${codigoNCM.codigoNCM}`}
        titulo='Código NCM'
        conteudo={codigoNCM.codigoNCM}
      />
      <InformacaoBasica
        aria-label={`Quantidade: ${formatStringToBR(codigoNCM.quantidade).toString()}`}
        titulo='Quantidade'
        conteudo={formatStringToBR(codigoNCM.quantidade).toString()}
      />
      <InformacaoBasica aria-label={`Valor: ${codigoNCM.valor}`} titulo='Valor' conteudo={codigoNCM.valor} />
      <InformacaoBasica
        aria-label={`Custo: ${codigoNCM.valor}`}
        titulo='Custo unitário'
        conteudo={formatCurrency(Number(codigoNCM.valor) / Number(codigoNCM.quantidade))}
      />
      {!hideAction && (
        <div className={styles.botoes}>
          <BrButton secondary circle onClick={() => removerNCM(codigoNCM)} title='Excluir'>
            <i className={`fas fa-trash-alt fa-md  ${styles.columnIcon}`} />
          </BrButton>
        </div>
      )}
    </div>
  );
};

export default NCMViewContainer;
